'use client';

import React, { useState, useEffect } from 'react';
import { CurrencyIcons } from '@skin-seoul/service';
import type { Country } from '@skin-seoul/service';
import { CountryChangeModal } from '../CountryChangeModal/CountryChangeModal';

const COUNTRY_BUTTON_TEST_ID = 'header-country-change-button';

type CountryChangeButtonProps = {
  country: Country;
  onCountryChange?: (country: Country) => void;
  className?: string;
};

export const CountryChangeButton = ({ country, onCountryChange, className }: CountryChangeButtonProps) => {
  const [currentCountry, setCurrentCountry] = useState<Country>(country);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setCurrentCountry(country);
  }, [country]);

  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (onCountryChange) {
      onCountryChange(currentCountry);
    }
  };

  return (
    <div className={`flex ${className || ''}`}>
      <button
        className="cursor-pointer min-w-6 min-h-6 border-none bg-transparent p-0 flex"
        data-testid={COUNTRY_BUTTON_TEST_ID}
        onClick={handleClick}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          alt={`${currentCountry} flag`}
          height={24}
          width={24}
          src={CurrencyIcons[currentCountry]}
          style={{
            borderRadius: '50%',
            display: 'block',
            objectFit: 'cover',
            border: '1px solid #605D66',
          }}
          loading="lazy"
          data-country={currentCountry}
        />
      </button>
      <CountryChangeModal initialCountry={currentCountry} isOpen={isModalOpen} onClose={handleModalClose} />
    </div>
  );
};
